import styled from "styled-components";

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: min(620px, 100%);
  margin: 0;
  min-height: 40px;
  padding: 1.4rem;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(10, 10, 10, 0.08);

  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 10px;
  }
`;

export const FormField = styled.div`
  margin-bottom: 14px;
  width: calc(50% - 8px);

  @media (max-width: 767px) {
    width: 100%;
  }
`;
export const FormFieldMessage = styled.div`
  margin-bottom: 14px;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 0.92rem;
  font-weight: 600;
  display: block;
  display: flex;
  align-items: center;
  margin-bottom: 0.45rem;
  .requiredField {
    color: ${({ theme }) => theme.colors.secondary};
  }
  svg {
    margin-right: 8px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 0.8rem;
  font-size: 0.95rem;
  border: 1px solid #d7dec5;
  border-radius: 8px;
  background: #f8faef;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(171, 198, 41, 0.2);
  }

  &[aria-invalid="true"] {
    border-color: #d33f49;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 150px;
  resize: vertical;
  padding: 0.75rem 0.8rem;
  font-size: 0.95rem;
  border: 1px solid #d7dec5;
  border-radius: 8px;
  max-width: -webkit-fill-available;
  background: #f8faef;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(171, 198, 41, 0.2);
  }

  &[aria-invalid="true"] {
    border-color: #d33f49;
  }
`;

export const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: black;
  padding: 0.75rem 1.1rem;
  font-size: 0.95rem;
  width: fit-content;
  color: #0a0a0a;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 8px;
  border: none;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    margin-right: 6px;
  }

  &:hover {
    color: white;
    background-color: #97b021;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.p`
  color: #d33f49;
  font-size: 0.82rem;
  margin: 0.35rem 0 0;
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const TextField = styled.div`
  margin-bottom: 14px;
  width: calc(50% - 8px);

  @media (max-width: 767px) {
    width: 100%;
  }
`;
export const ContactTitle = styled.h1`
  font-size: 26px;
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  height: 50px;
  width: 100%;
  align-items: center;
  text-align: center;
`;

export const ContactFormWrapper = styled.div`
  display: flex;
  width: min(1200px, 92%);
  margin: 0 auto;
  justify-content: space-between;
  align-items: flex-start;
  padding: 50px 0;
  gap: 28px;

  @media (max-width: 1023px) {
    flex-direction: column;
    width: 100%;
    padding: 24px 20px;
  }
`;
export const ContactDetails = styled.div`
  width: calc(42% - 10px);
  background: #0d0d0d;
  color: #f4f4f4;
  border-radius: 14px;
  padding: 1.4rem;
  box-shadow: 0 14px 30px rgba(10, 10, 10, 0.2);

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
`;
export const IconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;
export const ContactsWrapper = styled.ul``;

export const ContactWrapperList = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  svg {
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.primary};
  }

  a {
    font-weight: 700;
    color: #f4f4f4;
  }
  a {
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
export const ContactTitleFirst = styled.h1`
  font-size: 0.88rem;
  font-weight: 400;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ContactQuestionTitle = styled.p`
  font-size: clamp(1.7rem, 3.6vw, 2.4rem);
  font-weight: 600;
  line-height: 1.15;
  margin: 0;
`;

export const ContactParagraph = styled.p`
  line-height: 1.75;
  margin: 1rem 0 1.1rem;
  color: #e7e7e7;
`;

export const TelephoneWrapper = styled.a`
  font-weight: 700;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const SuccessMessage = styled.p`
  margin: 0;
  width: min(620px, 100%);
  background: #f4f8e8;
  color: #1f3d10;
  border: 1px solid #c7dca1;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  line-height: 1.7;
  font-weight: 600;
`;

export const SubmitErrorMessage = styled.p`
  margin: 0 0 0.8rem;
  width: 100%;
  background: #fff4f4;
  color: #8b1d26;
  border: 1px solid #f0b0b5;
  border-radius: 8px;
  padding: 0.7rem 0.8rem;
  font-size: 0.9rem;
`;
